module.exports = __webpack_public_path__ + "img/icn_account_off.1425ad1e.svg";